export const getCommonMatches = {
  matchUpStatistics: {
    matchUps: {
      items: [
        {
          id: '1',
          start: '2022-01-01T00:00:00.000Z',
          tournament: {
            id: '',
            name: 'CL Test',
            __typename: 'Tournament',
          },
          winningSide: 'SIDE2',
          status: 'COMPLETED',
          score: {
            superTiebreak: null,
            sets: [
              {
                winnerGamesWon: 6,
                loserGamesWon: 4,
                tiebreaker: null,
                __typename: 'Set',
              },
              {
                winnerGamesWon: 6,
                loserGamesWon: 4,
                tiebreaker: null,
                __typename: 'Set',
              },
            ],
            __typename: 'Score',
          },
          sides: [
            {
              players: [
                {
                  person: {
                    id: '60a4ed4bbf0fe5a6987890a2',
                    nationalityCode: 'USA',
                    nativeGivenName: 'Juliette',
                    nativeFamilyName: 'Prince',
                    __typename: 'Person',
                  },
                  __typename: 'Player',
                },
              ],
              __typename: 'Side',
            },
            {
              players: [
                {
                  person: {
                    id: '614c4017f60ae6bf2379793a',
                    nationalityCode: 'USA',
                    nativeGivenName: 'Jesse',
                    nativeFamilyName: 'Goldman',
                    __typename: 'Person',
                  },
                  __typename: 'Player',
                },
              ],
              __typename: 'Side',
            },
          ],
          worldTennisNumbers: [
            {
              type: 'SINGLE',
              tennisNumber: 34.03,
              personId: '614c4017f60ae6bf2379793a',
              __typename: 'MatchUpWorldTennisNumber',
            },
            {
              type: 'SINGLE',
              tennisNumber: 31.3,
              personId: '60a4ed4bbf0fe5a6987890a2',
              __typename: 'MatchUpWorldTennisNumber',
            },
          ],
          __typename: 'MatchUp',
        },
        {
          id: '2',
          start: '2022-01-01T00:00:00.000Z',
          tournament: {
            id: '',
            name: 'Elena - Test ',
            __typename: 'Tournament',
          },
          winningSide: 'SIDE2',
          status: 'COMPLETED',
          score: {
            superTiebreak: null,
            sets: [
              {
                winnerGamesWon: 6,
                loserGamesWon: 4,
                tiebreaker: null,
                __typename: 'Set',
              },
              {
                winnerGamesWon: 6,
                loserGamesWon: 4,
                tiebreaker: null,
                __typename: 'Set',
              },
            ],
            __typename: 'Score',
          },
          sides: [
            {
              players: [
                {
                  person: {
                    id: '60a4ed4bbf0fe5a6987890a2',
                    nationalityCode: 'USA',
                    nativeGivenName: 'Juliette',
                    nativeFamilyName: 'Prince',
                    __typename: 'Person',
                  },
                  __typename: 'Player',
                },
              ],
              __typename: 'Side',
            },
            {
              players: [
                {
                  person: {
                    id: '614c4017f60ae6bf2379793a',
                    nationalityCode: 'USA',
                    nativeGivenName: 'Jesse',
                    nativeFamilyName: 'Goldman',
                    __typename: 'Person',
                  },
                  __typename: 'Player',
                },
              ],
              __typename: 'Side',
            },
          ],
          worldTennisNumbers: [
            {
              type: 'SINGLE',
              tennisNumber: 34.03,
              personId: '614c4017f60ae6bf2379793a',
              __typename: 'MatchUpWorldTennisNumber',
            },
            {
              type: 'SINGLE',
              tennisNumber: 31.3,
              personId: '60a4ed4bbf0fe5a6987890a2',
              __typename: 'MatchUpWorldTennisNumber',
            },
          ],
          __typename: 'MatchUp',
        },
        {
          id: '3',
          start: '2022-01-01T00:00:00.000Z',
          tournament: {
            id: '',
            name: 'TestingTournament4',
            __typename: 'Tournament',
          },
          winningSide: 'SIDE2',
          status: 'COMPLETED',
          score: {
            superTiebreak: {
              winnerPointsWon: 10,
              loserPointsWon: 7,
              __typename: 'Tiebreaker',
            },
            sets: [
              {
                winnerGamesWon: 6,
                loserGamesWon: 4,
                tiebreaker: null,
                __typename: 'Set',
              },
              {
                winnerGamesWon: 6,
                loserGamesWon: 4,
                tiebreaker: null,
                __typename: 'Set',
              },
            ],
            __typename: 'Score',
          },
          sides: [
            {
              players: [
                {
                  person: {
                    id: '60a4ed4bbf0fe5a6987890a2',
                    nationalityCode: 'USA',
                    nativeGivenName: 'Juliette',
                    nativeFamilyName: 'Prince',
                    __typename: 'Person',
                  },
                  __typename: 'Player',
                },
              ],
              __typename: 'Side',
            },
            {
              players: [
                {
                  person: {
                    id: '614c4017f60ae6bf2379793a',
                    nationalityCode: 'USA',
                    nativeGivenName: 'Jesse',
                    nativeFamilyName: 'Goldman',
                    __typename: 'Person',
                  },
                  __typename: 'Player',
                },
              ],
              __typename: 'Side',
            },
          ],
          worldTennisNumbers: [
            {
              type: 'SINGLE',
              tennisNumber: 34.03,
              personId: '614c4017f60ae6bf2379793a',
              __typename: 'MatchUpWorldTennisNumber',
            },
            {
              type: 'SINGLE',
              tennisNumber: 31.3,
              personId: '60a4ed4bbf0fe5a6987890a2',
              __typename: 'MatchUpWorldTennisNumber',
            },
          ],
          __typename: 'MatchUp',
        },
        {
          id: '4',
          start: '2022-01-01T00:00:00.000Z',
          tournament: {
            id: '',
            name: 'TestingTournament4',
            __typename: 'Tournament',
          },
          winningSide: 'SIDE2',
          status: 'COMPLETED',
          score: {
            superTiebreak: null,
            sets: [
              {
                winnerGamesWon: null,
                loserGamesWon: null,
                tiebreaker: {
                  loserPointsWon: 4,
                  winnerPointsWon: 10,
                  __typename: 'Tiebreaker',
                },
                __typename: 'Set',
              },
              {
                winnerGamesWon: null,
                loserGamesWon: null,
                tiebreaker: {
                  loserPointsWon: 10,
                  winnerPointsWon: 8,
                  __typename: 'Tiebreaker',
                },
                __typename: 'Set',
              },
              {
                winnerGamesWon: null,
                loserGamesWon: null,
                tiebreaker: {
                  loserPointsWon: 6,
                  winnerPointsWon: 10,
                  __typename: 'Tiebreaker',
                },
                __typename: 'Set',
              },
            ],
            __typename: 'Score',
          },
          sides: [
            {
              players: [
                {
                  person: {
                    id: '60a4ed4bbf0fe5a6987890a2',
                    nationalityCode: 'USA',
                    nativeGivenName: 'Juliette',
                    nativeFamilyName: 'Prince',
                    __typename: 'Person',
                  },
                  __typename: 'Player',
                },
              ],
              __typename: 'Side',
            },
            {
              players: [
                {
                  person: {
                    id: '614c4017f60ae6bf2379793a',
                    nationalityCode: 'USA',
                    nativeGivenName: 'Jesse',
                    nativeFamilyName: 'Goldman',
                    __typename: 'Person',
                  },
                  __typename: 'Player',
                },
              ],
              __typename: 'Side',
            },
          ],
          worldTennisNumbers: [
            {
              type: 'SINGLE',
              tennisNumber: 34.03,
              personId: '614c4017f60ae6bf2379793a',
              __typename: 'MatchUpWorldTennisNumber',
            },
            {
              type: 'SINGLE',
              tennisNumber: 31.3,
              personId: '60a4ed4bbf0fe5a6987890a2',
              __typename: 'MatchUpWorldTennisNumber',
            },
          ],
          __typename: 'MatchUp',
        },
      ],
      totalItems: 4,
      __typename: 'MatchUpList',
    },
    __typename: 'MatchUpVsStatistics',
  },
}
